import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AclRole } from '../../../identite/shared/classes/acl_role';
import { AlertService } from '../../services/alert.service';
import { StorageService } from '../../services/storage.service';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { IdentiteService } from '../../../identite/shared/services/identite.service';
import { TRANSLATE } from '../../classes/translatable';
import { imgCardDrop } from '../../classes/animations';

@Component({
  selector: 'app-admin-list-role',
  templateUrl: './admin-list-role.component.html',
  styleUrls: ['./admin-list-role.component.css'],
  animations: [imgCardDrop]
})
export class AdminListRoleComponent implements OnInit {

    selected = new FormControl(0);
    newAclRole = new AclRole();
    newAclRoleOriginId: string = null;
    lstAclRolesCustom: AclRole[];
    lstAclRoles: AclRole[];
    aclConfig: AclAccess;
    showCustomSelect = false;

    /*@Input()
    triggerReload: () => void;*/

    @Output() triggerReload = new EventEmitter();

    constructor(
        private alertService: AlertService,
        private storageService: StorageService,
        private identiteService: IdentiteService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.lstAclRolesCustom = [];

        this.getAclRoles();
    }

    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            // this.getAclRolesCustom();
            this.getAclRoles();
        }
    }

    resetSelectedRoleOrigin() {
        this.newAclRoleOriginId = null;
    }

    resetNewAclRole() {
        this.newAclRole = new AclRole();
        this.newAclRoleOriginId = null;
        this.showCustomSelect = false;
    }

    getAclRoles() {
        this.lstAclRoles = [];
        this.identiteService.getRolesUtilisateur()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.lstAclRoles.push(new AclRole(element));
                });
            }
        });
    }

    getAclRolesCustom() {
        this.lstAclRolesCustom = [];
        this.identiteService.getRolesUtilisateur(true)
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.lstAclRolesCustom.push(new AclRole(element));
                });
            }
        });
    }

    insertAclRole() {
        this.identiteService.insertRolesUtilisateur(this.newAclRole, this.newAclRoleOriginId)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Rôle ajouté avec succès'));
                if (this.triggerReload) {
                    this.triggerReload.emit(new AclRole(retour.data));
                }
                this.resetNewAclRole();
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateAclRoleCustom(aclRole: AclRole) {
        this.identiteService.updateRolesUtilisateur(aclRole.id, aclRole)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Rôle mis à jour avec succès'));
                if (this.triggerReload) {
                    this.triggerReload.emit();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteAclRoleCustom(aclRole: AclRole) {
        this.identiteService.deleteRolesUtilisateur(aclRole.id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Rôle supprimé avec succès'));
                // this.getAclRolesCustom();
                this.getAclRoles();
                if (this.triggerReload) {
                    this.triggerReload.emit();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }
}
